import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import { searchFilter } from "../../features/Search/searchSlice";

export default function Navbar() {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(searchFilter(searchValue));
  };
  return (
    <nav className="container relative py-3">
      <div className="flex items-center justify-between">
        <Link to="/">
          <img src={logo} alt="Logo" />
        </Link>
        {/* <!-- There are nothing to do with the search in add or edit task page, but kept for looking good --> */}
        <form
          className="flex-1 max-w-xs search-field group"
          onSubmit={handleSubmit}
        >
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
          <input
            type="text"
            placeholder="Search Job"
            className="search-input"
            id="lws-searchJob"
            name="search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </form>
      </div>
    </nav>
  );
}
